var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gif-display-popup" }, [
    _c("div", { staticClass: "gif-overlay", on: { click: _vm.closeGifs } }),
    _vm._v(" "),
    _c(
      "div",
      { ref: "gifBoxScroller", staticClass: "gif-box" },
      [
        _vm._l(_vm.gifs, function(g) {
          return _c(
            "div",
            { key: g.id, staticClass: "gif" },
            [
              _c("q-media", {
                attrs: {
                  size: { width: "100%" },
                  src: g.images.downsized_medium.gif_url,
                  mediaObject: g
                },
                on: { click: _vm.selectGif }
              })
            ],
            1
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "giphy-logo" }, [
          _c("div", [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "loading-gifs giphy-logo" },
                  [
                    _c("q-icon", {
                      attrs: {
                        allowSelfUpdate: false,
                        spin: "",
                        width: "110px",
                        name: "spinner"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "giphy-logo text-center" },
              [
                _c("q-image", {
                  staticClass: "image-bg",
                  attrs: { name: "giphy", pack: "clear" }
                })
              ],
              1
            )
          ])
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7502cc1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7502cc1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/display/GifDisplay.vue
// module id = null
// module chunks = 